export const UPDATED_SIZE = 'UPDATED_SIZE';

export function updatedSize(deviceSizes = {}, clientSideMismatch = false) {
    return {
        type: UPDATED_SIZE,
        payload: Object.assign({}, deviceSizes, {
            clientSideMismatch: clientSideMismatch
        })
    };
}
